import { render, staticRenderFns } from "./StatusRegionItem.vue?vue&type=template&id=7274a5ac&scoped=true&"
import script from "./StatusRegionItem.vue?vue&type=script&lang=js&"
export * from "./StatusRegionItem.vue?vue&type=script&lang=js&"
import style0 from "./StatusRegionItem.vue?vue&type=style&index=0&id=7274a5ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274a5ac",
  null
  
)

export default component.exports